import { Index } from 'flexsearch';
import { getSearchablePages } from './wikiData';

const caches = {};

function getIndex(language) {
  const lang = language === 'zh' ? 'zh' : 'en';
  if (caches[lang]) return caches[lang];

  const pages = getSearchablePages(lang);
  const index = new Index({ tokenize: 'forward', cache: true });
  pages.forEach((p, i) => {
    index.add(i, p.searchText);
  });
  caches[lang] = { index, pages };
  return caches[lang];
}

export function searchPages(query, language, limit = 20) {
  const q = query.trim();
  if (!q) return [];
  const { index, pages } = getIndex(language);
  const results = index.search(q, { limit });
  return results.map((i) => pages[i]).filter(Boolean);
}
